<template>
  <div class="boxbgcolor interimCarPayRecord">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>车牌号码:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>订单编号:</label>
            <input
              v-model="search.orderNum"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>付款方式:</label>
            <el-select v-model="search.payType" clearable placeholder="请选择">
              <el-option
                v-for="item in allPayTypeData"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>放行类型:</label>
            <el-select
              v-model="search.openmethodType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in allOpenmethodTypeData"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>缴费时间:</label>
            <el-date-picker
              v-model="search.chargeTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="others">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          :data="tableListData.rows"
          border
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingId"
          >
            <template slot-scope="scope">{{
              scope.row.parkingId
                ? JSON.parse(scope.row.parkingId).parkingName
                : ""
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="订单编号"
            prop="orderNum"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="车牌号码" prop="lmId">
            <template slot-scope="scope">{{
              scope.row.lmId ? JSON.parse(scope.row.lmId).plateNumber : ""
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="应付金额"
            prop="receivable"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="已付金额"
            prop="realMoney"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="对账金额"
            prop="realMoney"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="折扣值"
            prop="discountsMsgId"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.discountsMsgId">
                <span>{{
                  JSON.parse(scope.row.discountsMsgId).subtractMoney ||
                    JSON.parse(scope.row.discountsMsgId).subtractTime
                }}</span>
                <span v-if="JSON.parse(scope.row.discountsMsgId).subtractMoney"
                  >元</span
                >
                <span v-if="JSON.parse(scope.row.discountsMsgId).subtractTime"
                  >分钟</span
                >
              </template>
              <template v-else>{{ (0.0).toFixed(2) }}</template>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="未付金额">
            <template slot-scope="scope">{{
              (scope.row.receivable - scope.row.realMoney).toFixed(2)
            }}</template>
          </el-table-column>

          <!-- <el-table-column  show-overflow-tooltip
						label="开始时间"
						prop="lmId">
							<template slot-scope='scope'>
								{{scope.row.lmId?JSON.parse(scope.row.lmId).beginDate:''}}
							</template>
						</el-table-column>
						<el-table-column  show-overflow-tooltip
						label="结束时间"
						prop="lmId">
							<template slot-scope='scope'>
								{{scope.row.lmId?JSON.parse(scope.row.lmId).beginDate:''}}
							</template>
          </el-table-column>-->
          <el-table-column show-overflow-tooltip label="停车时长" prop="lmId">
            <template slot-scope="scope">{{
              scope.row.lmId ? JSON.parse(scope.row.lmId).parkingLongTime : ""
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="缴费时间"
            prop="chargeDate"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="付款方式"
            prop="payType"
          >
            <!-- <template slot-scope="scope">
              <span v-if='scope.row.payType=="-1"'></span>
              <span v-else>{{scope.row.payType}}</span>
            </template>-->
          </el-table-column>
          <el-table-column show-overflow-tooltip label="放行方式">
            <template slot-scope="scope">
              <span>{{ matchingOpenmethod(scope.row.lmId) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import dayjs from 'dayjs'
import {
  interimCarPayRecordAPI,
  requestAllPayType,
  requestOpenmethodType,
} from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      allFbType: [],
      allPayTypeData: [],
      allOpenmethodTypeData: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        chargeTime: [],
        payType: "",
        openmethodType: "",
        orderNum: "",
        plateNumber: "",
      },
      tableListData: {
        rows: [],
      },
      defaultProps: {
        children: "children",
        label: "label",
      },

      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.initSearchForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        this.tableListData.rows = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择停车场'
        // })
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.$get(interimCarPayRecordAPI(), {
        parkingId: this.treeData.parkingId,
        plateNumber: this.search.plateNumber,
        payType: this.search.payType,
        orderNum: this.search.orderNum,
        matchingMethod: this.search.openmethodType,
        beginTime: this.search.chargeTime ? this.search.chargeTime[0] : "",
        endTime: this.search.chargeTime ? this.search.chargeTime[1] : "",
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择车场",
        });
        return;
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      // this.search.pageNumber="1";
      // this.search.fbMsg="";
    },
    getAllPayType() {
      this.$get(requestAllPayType()).then((data) => {
        this.allPayTypeData = data.data.rows;
      });
    },
    getOpenmethodType() {
      this.$get(requestOpenmethodType()).then((data) => {
        this.allOpenmethodTypeData = data.data.rows;
      });
    },
    matchingOpenmethod(lmId) {
      let openmethod = "";
      if (lmId) {
        openmethod = JSON.parse(lmId).matchingMethod;
      }
      for (let item of this.allOpenmethodTypeData) {
        if (item.value === openmethod) {
          return item.labelDefault;
        }
      }
    },
    initSearchForm() {
      this.search = {
        plateNumber: "",
        payType: "",
        chargeTime: [],
        openmethodType: "",
        orderNum: "",
      };
    },
    downloadData() {
      const parkingId = this.treeData.parkingId;
      
      const {
        plateNumber,
        payType,
        orderNum,
        openmethodType,
        chargeTime,
      } = this.search;
      if(!(parkingId&&chargeTime.length>0&&dayjs(chargeTime[1]).diff(dayjs(chargeTime[0]),'day')<=90)){
         this.$message({
          type: "warning",
          message: "请选择车场和时间并且时间小于90天",
        });
        return;
      }
      const matchingMethod = openmethodType;
      const beginTime = dayjs(chargeTime[0]).format('YYYY-MM-DD HH:mm:ss');
      const endTime = dayjs(chargeTime[1]).format('YYYY-MM-DD HH:mm:ss');
    
      // window.open(`/api/onsite/onsiteOrders/ExportParkingOrders?${new URLSearchParams( {
      //     parkingId,
      //     plateNumber,
      //     payType,
      //     orderNum,
      //     matchingMethod,
      //     beginTime,
      //     endTime
      //   }).toString()}`)
        window.open(`/api/onsite/onsiteOrders/ExportParkingOrders?parkingId=${parkingId}&plateNumber=${plateNumber}&payType=${payType}&orderNum=${orderNum}&matchingMethod=${matchingMethod}&beginTime=${beginTime}&endTime=${endTime}`)
      // this.$downloadFileRequest(
      //   "/api/onsite/onsiteOrders/ExportParkingOrders",
      //   {
      //     parkingId,
      //     plateNumber,
      //     payType,
      //     orderNum,
      //     matchingMethod,
      //     beginTime,
      //     endTime
      //   },
      //   "临停缴费"
      // );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
    AreaTree,
    Refresh,
  },

  mounted: function() {
    this.getAllPayType();
    this.getOpenmethodType();
    // this.tableList(this.search.pageNumber)
  },
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
</style>
<style>
.interimCarPayRecord .el-select {
  width: 100px !important;
}
</style>
